import { Observable } from 'rxjs';
import { NimbusIcon } from '@nimbus-library/features/shared/directives/nimbus-icon.directive';
import { IMenuIndicator, MenuEntryType } from '@nimbus-library/features/menu/models/menu-entry.model';

export class MenuEntryViewModel {
  public readonly name: string;
  public readonly icon: NimbusIcon;
  public readonly indicator: IMenuIndicator;
  public readonly filter$: Observable<boolean>;
  public readonly renderAs?: MenuEntryType;
  public readonly path?: string;
  public readonly subEntries?: Array<MenuEntryViewModel>;
  public readonly subClass?: string;
  public readonly connectedPaths?: string[];
  /** Optional stream of a custom image URL used in place of {@link icon} when non-empty. */
  public readonly customImageUrl$?: Observable<string | null>;
  /** Optional stream of custom tooltip text used in place of the translated {@link name} when non-empty. */
  public readonly customTooltip$?: Observable<string | null>;

  public constructor(
    name: string,
    icon: NimbusIcon,
    indicator: IMenuIndicator,
    filter$: Observable<boolean>,
    path?: string,
    subEntries?: Array<MenuEntryViewModel>,
    subClass?: string,
    connectedPaths?: string[],
    customImageUrl$?: Observable<string | null>,
    customTooltip$?: Observable<string | null>,
    renderAs?: MenuEntryType,
  ) {
    this.name = name;
    this.icon = icon;
    this.indicator = indicator;
    this.filter$ = filter$;
    this.path = path;
    this.subEntries = subEntries;
    this.subClass = subClass;
    this.connectedPaths = connectedPaths;
    this.customImageUrl$ = customImageUrl$;
    this.customTooltip$ = customTooltip$;
    this.renderAs = renderAs;
  }
}
